<template>
  <div class="selection:bg-[var(--terracotta)] selection:text-white min-h-screen bg-[var(--cream)]">
    <section class="min-h-screen flex items-center justify-center pt-24 pb-24 px-4 md:px-6">
      <div class="max-w-4xl mx-auto text-center fade-in-content">
        <div class="space-y-8 md:space-y-12">
          <!-- 404 Number -->
          <div class="space-y-4">
            <h1 class="text-8xl md:text-9xl lg:text-[12rem] font-bold text-[var(--forest)] italic leading-none">
              404
            </h1>
            <div class="w-32 md:w-40 h-1.5 md:h-2 bg-[var(--terracotta)] rounded-full mx-auto"></div>
          </div>

          <!-- Message -->
          <div class="space-y-6">
            <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--forest)] italic">
              Page Not Found
            </h2>
            <p class="text-lg md:text-xl text-[var(--moss)] font-light leading-relaxed italic max-w-2xl mx-auto">
              The page you're looking for doesn't exist or has been moved. Let's help you find your way back to Safe Haven.
            </p>
          </div>

          <!-- Decorative blob element with image -->
          <div class="relative flex justify-center items-center py-8">
            <div class="size-48 md:size-64 rounded-[40%_60%_30%_70%/60%_30%_70%_40%] overflow-hidden border-4 md:border-8 border-white shadow-2xl bg-cover bg-center" style="background-image: url('/images/(28).jpeg');"></div>
          </div>

          <!-- Action buttons -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <router-link
              to="/"
              class="btn-organic bg-[var(--forest)] text-white px-10 py-4 text-lg font-bold shadow-xl hover:bg-[var(--forest)]/90 inline-block"
            >
              Back to Home
            </router-link>
            <router-link
              to="/bio"
              class="btn-organic bg-transparent border-2 border-[var(--forest)] text-[var(--forest)] px-10 py-4 text-lg font-bold hover:bg-[var(--forest)]/5 inline-block"
            >
              Meet Our Founders
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'NotFoundPage',
  setup() {
    const setupFadeIn = () => {
      const contentElements = document.querySelectorAll('.fade-in-content')
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.classList.contains('fade-in-visible')) {
            entry.target.classList.add('fade-in-visible')
            observer.unobserve(entry.target)
          }
        })
      }, {
        rootMargin: '-10% 0px -10% 0px',
        threshold: 0.1
      })

      contentElements.forEach((content) => {
        observer.observe(content)
      })
    }

    onMounted(() => {
      setupFadeIn()
    })
  }
}
</script>

<style scoped>
.fade-in-content {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-content.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}
</style>
